<template>
    <div>
        <div class="modal hide fade" id="modalCustomerForm" tabindex="-1" role="dialog" aria-labelledby="modalCustomerForm" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">
                            Customer
                        </h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group row">
                                    <label for="group_id" class="col-sm-3 col-form-label text-left">&nbsp;</label>
                                    <div class="col-sm-9">
                                        <div class="custom-control custom-checkbox">
                                            <input type="checkbox" id="canBarcode" data-parsley-multiple="groups" data-parsley-mincheck="2" class="custom-control-input" v-model="customer.active" :disabled="authUser.permissions.customer_active === false">
                                            <label for="canBarcode" class="custom-control-label">Active</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="group_id" class="col-sm-3 col-form-label text-left">&nbsp;</label>
                                    <div class="col-sm-9">
                                        <div class="custom-control custom-checkbox">
                                            <input type="checkbox" id="rating_auto" data-parsley-multiple="groups" data-parsley-mincheck="2" class="custom-control-input" v-model="customer.rating_auto">
                                            <label for="rating_auto" class="custom-control-label">Auto Rating</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="term_due_id" class="col-sm-3 col-form-label text-left">Term Due</label>
                                    <div class="col-sm-9">
                                        <select class="form-control" v-model="customer.term_due_id">
                                            <option v-for="r in termDueList" :key="r.id" :value="r.id">{{ r.name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="group_id" class="col-sm-3 col-form-label text-left">Group</label>
                                    <div class="col-sm-9">
                                        <div class="form-check form-check-inline" v-for="g in customerGroupList" :key="g.id">
                                            <input class="form-check-input" type="radio" :id="g.id" :value="g.id" v-model="customer.group_id">
                                            <label class="form-check-label" :for="g.id">{{ g.name }}</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="name" class="col-sm-3 col-form-label text-left">Name</label>
                                    <div class="col-sm-9">
                                        <input type="text" v-model="customer.name" class="form-control" :disabled="customer.id"/>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="email" class="col-sm-3 col-form-label text-left">Email</label>
                                    <div class="col-sm-9">
                                        <input type="text" class="form-control" v-model="customer.email"/>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="phone" class="col-sm-3 col-form-label text-left">Phone</label>
                                    <div class="col-sm-9">
                                        <input type="text" v-model="customer.phone" class="form-control"/>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="address" class="col-sm-3 col-form-label text-left">Address</label>
                                    <div class="col-sm-9">
                                        <textarea rows="5" v-model="customer.address" class="form-control"/>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group row">
                                    <label for="state_id" class="col-sm-3 col-form-label text-left">State</label>
                                    <div class="col-sm-9">
                                        <select v-model="customer.state_id" class="form-control">
                                            <option v-for="s in stateList" :key="s.id" :value="s.id">{{ s.name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="city_id" class="col-sm-3 col-form-label text-left">City</label>
                                    <div class="col-sm-9">
                                        <select v-model="customer.city_id" class="form-control">
                                            <option v-for="c in cityList" :key="c.id" :value="c.id">{{ c.name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="area_id" class="col-sm-3 col-form-label text-left">Area</label>
                                    <div class="col-sm-9">
                                        <select v-model="customer.area_id" class="form-control">
                                            <option v-for="a in areaList" :key="a.id" :value="a.id">{{ a.name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="identity_number" class="col-sm-3 col-form-label text-left">No. KTP</label>
                                    <div class="col-sm-9">
                                        <input type="text" v-model="customer.identity_number" class="form-control"/>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="vat" class="col-sm-3 col-form-label text-left">NPWP</label>
                                    <div class="col-sm-9">
                                        <input type="text" v-model="customer.vat" class="form-control"/>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="plafond_type" class="col-sm-3 col-form-label text-left">Plafond Type</label>
                                    <div class="col-sm-9">
                                        <select v-model="customer.plafond_type" class="form-control">
                                            <option value="omzet">Omzet</option>
                                            <option value="outstanding">Outstanding</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="plafond_amount" class="col-sm-3 col-form-label text-left">Plafond Amount</label>
                                    <div class="col-sm-9">
                                        <input type="text" v-model="customer.plafond_amount" class="form-control" v-money="money">
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label for="vat" class="col-sm-3 col-form-label text-left">Notes</label>
                                    <div class="col-sm-9">
                                        <textarea v-model="customer.notes" class="form-control" rows="5"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-success" data-dismiss="modal" @click="save">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios'
import { customerUrl, getHeader } from '../../config'
export default {
  name: 'CustomerFormModal',
  data () {
    return {
      money: {
        total: '0',
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      },
      customer: {
        id: null,
        name: null,
        customer_no: null,
        group_id: null,
        email: null,
        phone: null,
        address: null,
        city_id: null,
        state_id: null,
        identity_number: null,
        vat: null,
        birthday: null,
        birthplace: null,
        twitter: null,
        facebook: null,
        instagram: null,
        card_id: null,
        level_id: null,
        company_no: null,
        area_id: null,
        rating_id: null,
        term_due_id: null,
        active: true,
        notes: null,
        rating_auto: true,
        plafond_type: null,
        plafond_amount: null
      }
    }
  },
  computed: {
    ...mapState({
      cityList: state => state.city.cityList,
      stateList: state => state.state.stateList,
      areaList: state => state.area.areaList,
      customerGroupList: state => state.customers.customerGroupList,
      customerRatingList: state => state.customers.customerRatingList,
      termDueList: state => state.termduedates.termDueList,
      authUser: state => state.users.authUser
    })
  },
  methods: {
    save: function () {
      console.log(this.customer)
      console.log(customerUrl)
      const obj = {
        id: null,
        name: this.customer.name,
        customer_no: null,
        group_id: this.customer.group_id,
        email: this.customer.email,
        phone: this.customer.phone,
        address: this.customer.address,
        city_id: this.customer.city_id,
        state_id: this.customer.state_id,
        identity_number: this.customer.identity_number,
        vat: this.customer.vat,
        birthday: this.customer.birthday,
        birthplace: this.customer.birthplace,
        twitter: this.customer.twitter,
        facebook: this.customer.facebook,
        instagram: this.customer.instagram,
        card_id: this.customer.card_id,
        level_id: this.customer.level_id,
        company_no: this.customer.company_no,
        area_id: this.customer.area_id,
        rating_id: 'evaluate',
        term_due_id: this.customer.term_due_id,
        active: this.customer.active,
        notes: this.customer.notes,
        rating_auto: true,
        plafond_type: this.customer.plafond_type,
        plafond_amount: this.customer.plafond_amount.replace(/\./g, '')
      }
      axios.post(customerUrl, obj, { headers: getHeader(), timeout: process.env.VUE_APP_TIMEOUT })
        .then(response => {
          this.$emit('createCustomer', response.data.data)
        })
        .catch(error => {
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
        })
    }
  }
}
</script>
